// src/components/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';

const PrivateRoute = ({ children }) => {
    const { user, loading } = useAuth();
    const { t } = useTranslation();

    // Пока идет проверка аутентификации, показываем загрузку
    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '70vh' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">{t('common.loading')}</span>
                </div>
            </div>
        );
    }

    // Если пользователь не авторизован, перенаправляем на страницу входа
    if (!user) {
        // Сохраняем текущий путь для возможного перенаправления обратно после логина
        return <Navigate to="/login" replace />;
    }

    // Если пользователь авторизован, показываем содержимое защищенного маршрута
    return children;
};

export default PrivateRoute;